<template>
  <v-dialog max-width="55.0rem" v-model="openBox" @keydown.esc="closeBox">
    <v-card id="view" class="card-padding" max-width="100%">
      <div v-if="!loading">
        <div class="heading-text">
          <v-icon @click="closeBox" style="float: right;" size="32"
            >mdi-close-box</v-icon
          >
        </div>
        <object :data="src" type="application/pdf" width="100%" height="600rem">
          <embed :src="src" type="application/pdf" />
        </object>
      </div>
      <div class="row" style="height: 60rem" v-else>
        <div class="mx-auto my-auto loader"></div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { INVOICE_ACTION } from "../../../Api/admin_api";

export default {
  name: "view-invoice",
  props: {
    view_key: String
  },
  data: function() {
    return {
      loading: false,
      openBox: false,
      src: null,
      timeout: null
    };
  },
  methods: {
    viewInvoice() {
      const self = this;
      let key = self.view_key;
      INVOICE_ACTION(key)
        .then(function(data) {
          self.loading = false;
          self.timeout = setTimeout(function() {
            let ext = "#toolbar=0&navpanes=0&scrollbar=0";
            let elmnt = document.getElementById("view");
            self.src = data.url + ext;
            elmnt.scrollIntoView();
          }, 100);
        })
        .catch(function(error) {});
    },
    closeBox() {
      const self = this;
      self.openBox = false;
    }
  },
  beforeDestroy(){
    clearTimeout(this.timeout)
  },
  mounted() {
    this.openBox = true;
    this.loading = true;
    this.viewInvoice();
  }
};
</script>

<style scoped>
.card-padding {
  border: 0.1rem solid #cccccc !important;
  padding: 1rem;
}
.heading-text {
  font-size: 3rem;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 3.5rem;
  color: #050405;
  text-align: left;
}
.body-text {
  padding-top: 3rem;
  padding-bottom: 3rem;
  font-size: 1.6rem;
  letter-spacing: 0;
  line-height: 3.3rem;
  color: #3d4249;
  text-align: left;
}
.button-style {
  text-align: right;
}
.button-spacing {
  padding-left: 1rem;
}
</style>
